import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useBrandAppearance } from "../hooks/useBrandAppearance";

interface FooterActionButtonProps {
    isGuestDetailsPage: boolean;
    isFormValid: boolean;
    isProceedDisabled: boolean;
    onProceed: () => void;
    onSave: () => void;
    isMobile?: boolean;
    height?: string | number;
    width?: string | number;
    isSaving?: boolean;
}

const FooterActionButton: React.FC<FooterActionButtonProps> = ({
    isGuestDetailsPage,
    isFormValid,
    isProceedDisabled,
    onProceed,
    onSave,
    isMobile = false,
    height = isMobile ? "100%" : "110px",
    width = isMobile ? "30%" : "190px",
    isSaving = false,
}) => {
    const { colors: BrandColors } = useBrandAppearance();
    const { t } = useTranslation("footer");

    const handleClick = () => {
        if (isSaving) return; // guard double-clicks
        if (isGuestDetailsPage) {
            if (isFormValid) onSave();
        } else {
            if (!isProceedDisabled) onProceed();
        }
    };

    const isDisabled = isGuestDetailsPage ? (!isFormValid || isSaving) : (isProceedDisabled || isSaving);

    const label = isGuestDetailsPage
        ? (isSaving ? t("savingButton", { defaultValue: "Saving…" }) : t("saveButton"))
        : t("proceedButton");

    return (
        <Button
            variant="contained"
            disabled={isDisabled}
            onClick={handleClick}
            startIcon={isSaving && isGuestDetailsPage ? <CircularProgress size={18} /> : undefined}
            sx={{
                backgroundColor: isDisabled ? BrandColors.footerBtn : BrandColors.footerBtnDisabled,
                color: isDisabled ? "#A4957E" : "#FFFFFF",
                fontWeight: "bold",
                fontSize: isMobile ? "0.75rem" : "1rem",
                borderRadius: 0,
                width,
                height,
                minWidth: 0,
                "&:hover": {
                    backgroundColor: isDisabled ? BrandColors.footerBtn : BrandColors.footerBtnDisabled,
                },
            }}
        >
            {label}
        </Button>
    );
};

export default FooterActionButton;
